import {
  eventBus
} from '../eventbus'

export default {
  methods: {
    navigateTo: function (id, fid, focus, path) {
      var string_path;
      try {
        if (path != null) {
          string_path = path;
        } else {
          string_path = this.$route.query.p;
        }
      } catch (err) {}

      if (string_path != null) {
        var searching_path = []
        if (string_path == '') {
          string_path = [];
        } else {
          string_path = string_path.split('?');
        }

        var index = string_path.indexOf(id);
        if (index != -1 && !fid) {
          //in un'operazione di navigazione diretta, solitamente o navigo verso un figlio dell'elemento attivo, o verso un elemento all'interno della gerarchia
          //se trovo l'elemento all'interno del path, mi trovo nel secondo caso, e devo estrarre la porzione di percorso adeguata
          string_path = string_path.slice(0, index) // slice dovrebbe comprendere il primo indice ed escludere il secondo
        } else {
          if (fid) {
            //dove posso, cerco di portarmi dietro anche il riferimento al padre, così che possa controllare anche la sua presenza nel percorso
            var father = string_path.indexOf(fid)
            if (father == -1) {
              //se manca, lo agguingo in coda prima dell'id ricercato
              //serve ad esempio quando navigo dalla tabella di dettaglio, in cui cerco un figlio dell'elemento corrente (che non è a sua volta riportato nella query di vue router)
              string_path.push(fid)
            } else {
              //se esiste, posso estrarre quella parte di percorso (lui compreso), ed essere sicuro di trovare il risultato fra i suoi figli
              string_path = string_path.slice(0, (father + 1))
            }
          }
        }
        for (var i = 0; i < string_path.length; i++) {
          searching_path.push({
            id: string_path[i]
          })
        }
        //aggiungo al percorso l'obbiettivo ultimo della ricerca
        searching_path.push({
          id: id
        })
        console.log(searching_path)

        //nuova promise per la risoluzione della navigazione, se la promise fallisce, chiedo ai services di crearmi un percorso adatto
        var vm = this;
        new Promise(function (resolve, reject) {
          vm.notifyTree(searching_path, focus, {
            "resolve": resolve,
            "reject": reject
          });
        }).then((res) => {
          //do nothing on resolve
          //console.log("nav ok")
        }, (err) => {
          console.log(err)
          //call command on reject
          if (fid != null) {
            vm.getRemotePath(id, fid, focus)
          } else {
            eventBus.$emit("alert", {
              type: "error",
              message: vm.$Jed.firstUpperTranslate("navigation error", null) + ", " + vm.$Jed.translate("better to refresh the page", null)
            })
          }

        });
      } else {
        this.getRemotePath(id, fid, focus)
      }
    },
    notifyTree: function (path, focus, nav_promise) {
      eventBus.$emit("nav_to", {
        path: path,
        focus: focus,
        nav_promise: nav_promise
      });
    },
    getRemotePath: function (sid, fid, focus) {
      this.microservice({
        role: "catalog",
        cmd: "GetNodePath",
        params: {
          fid: fid,
          sid: sid,
          root: this.index_as_root
        }
      }).then((response) => {
        var res = response.body;
        try {
          res = JSON.parse(response.body);
        } catch (err) {}
        var vm = this;
        console.log(res)
        new Promise(function (resolve, reject) {
          vm.notifyTree(res, focus, {
            "resolve": resolve,
            "reject": reject
          });
        }).then((res) => {
          //do nothing on resolve
          //console.log("nav ok")
        }, (err) => {
          console.log(err)
          //window.alert("LOAD INDEX")
          console.log("LOAD INDEX")
          console.log("got Index from error")
          console.log(err)
          eventBus.$emit("gotIndex")
        });
      }, (err) => {
        console.log(err)
        console.log("LOAD INDEX")
        console.log("got Index from error")
        console.log(err)
        eventBus.$emit("gotIndex")
        //vedi gestione errore in main.js > microservice
      })
      .catch(err => {
        console.log(err);
        var msg = err && err.body && err.body.error ? err.body.error : err
        eventBus.$emit('alert', {
            message: "Application caught an error <br> <h5>Details: " + "catalog.GetNodePath - " + msg +'</h5>',
            type: "error",
            action: ''
        })
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/direct_tree_navigation.js